import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CommentCreateEditForm from './Components/CommentCreateEditForm';
import CommentApi from './CommentApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CommentCreateEditForm,
                getCreate: CommentApi.create,
                defaults: {},
                successMessage: "Comment Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}